/**
 * This component is intended for use in showing the customer's balance, available balance, and float balance
 * within a reseller's view of the customer.  It is called from the CustomerProjectWallet component.
 */

import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment'; 
import withStyles from '@mui/styles/withStyles';
import { Grid } from '@mui/material';
import TextWidget from '../ui/TextWidget';
import LinearProgressWidget from '../ui/LinearProgressWidget';

const abEnvironment = new AbEnvironment();
const CustomerWalletBalanceTilesQuery = graphql`
query CustomerWalletBalanceTilesQuery($walletId: UUID!) {
  getwalletledgersummary(walletid: $walletId, balancedate: null) {
    assetBalance
    assetAndFullArBalance
    assetAndArBalance
    assetArAuthBalance
    authBalance
    floatBalanceForAuth
  }
}
`;

const styleSheet = theme => ({
  dbTile: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 212
  },
  dbTile2: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 184
  }
});

class CustomerWalletBalanceTiles extends Component {
    
  render() {
    const classes = this.props.classes;

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={CustomerWalletBalanceTilesQuery}
        variables={{walletId: this.props.walletId}}
        render={({error, props})=> {

          if (error) {
            return <div>{error.message}</div>
          } else if (props) {

            // For balance widget
            let bal = props.getwalletledgersummary.assetAndFullArBalance;
            let balance = Number(bal).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
            let balanceTitle = "Wallet balance";
            let balanceTt = "The balance of your customer's expense wallet.  This may include funds that haven't settled yet.";

            // For available balance widget
            let ab = props.getwalletledgersummary.assetArAuthBalance;
            let availableBalance = Number(ab).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
            let availableBalanceTitle = "Wallet available balance";
            let availableBalanceTt = "Your customer's available balance is the amount of funds in their expense wallet that are available to pay for subscriptions.  This may be lower than the total balance, as a portion of incoming funds will not be available until they have settled.";

            // Float widget
            let floatLimit = this.props.floatLimit;
            let floatBalance = props.getwalletledgersummary.floatBalanceForAuth;
            if (floatBalance < 0) {
              floatBalance = 0;
            }
            let floatLimitTitle1 = "Overdraft (";
            let floatLimitTitle2 = "% of limit)";
            let floatLimitTt = "We may provide your customer with an overdraft float for purchasing subscriptions.  This, plus your customer's available balance, is the amount available for subscription expenses.  Each individual charge typically clears within a few days, but if you provision a large number of subscriptions, your customer may need a higher limit."

            return (
              <Grid container spacing={3} direction="row" justifyContent="flex-start" alignItems="center">
                <Grid item>
                  <TextWidget
                    narrow={this.props.narrow}
                    value={balance}
                    description={balanceTitle}
                    tooltip={balanceTt}
                  />
                </Grid>
                <Grid item>
                  <TextWidget
                    narrow={this.props.narrow}
                    value={availableBalance}
                    description={availableBalanceTitle}
                    tooltip={availableBalanceTt}
                  />
                </Grid>
                <Grid item>
                  <LinearProgressWidget
                    narrow={this.props.narrow}
                    nominator={floatBalance}
                    denominator={floatLimit}
                    descriptionStart={floatLimitTitle1}
                    descriptionEnd={floatLimitTitle2}
                    tooltip={floatLimitTt}
                  />
                </Grid>
              </Grid>
            );
          }  
        }}
      />
    );
  }
}

export default withStyles(styleSheet)(CustomerWalletBalanceTiles);